jQuery( document ).ready(function() {
  if ($(window).width() < 768) {
       jQuery(document).scroll(function() {
    var y = jQuery(this).scrollTop();
    if (y > 600) {
      jQuery('.floating-btn').fadeIn();
    } else {
      jQuery('.floating-btn').fadeOut();
    }
  });
  }
  jQuery('.rubbee-vid-placeholder').click(function () {
        video = '<div class="rubbee-video" style="padding-bottom:56.25%; position:relative; display:block; width: 100%"><iframe width="100%" height="100%" src="' + jQuery(this).attr('data-video') + '" frameborder="0" allowfullscreen="" loading="lazy" style="position:absolute; top:0; left: 0"></iframe></div>';
      jQuery(this).replaceWith(video);
   });
  

});

